import { SearchState } from "@/contexts/SearchContext/interfaces";
import { PropertyListingType } from "@/enums/property.enum";

interface GetListingPageTitle
  extends Pick<SearchState, "locations" | "furnishing" | "listing"> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  t: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  st: any;
}

export function getListingPageTitle({
  st,
  t,
  furnishing,
  listing,
  locations,
}: GetListingPageTitle) {
  const getPrefix = () => {
    let text = "";

    if (furnishing) {
      text += t(furnishing);
    }

    if (
      listing.type === PropertyListingType.BUY ||
      listing.type === PropertyListingType.RENT
    ) {
      return text;
    }

    if (listing.type === PropertyListingType.OFF_PLAN) {
      text += t("off-plan");

      return text;
    }

    text += " ";
    text += t("commercial");

    return text;
  };

  const getSuffix = () => {
    if (
      listing.type === PropertyListingType.BUY ||
      listing.type === PropertyListingType.COMMERCIAL_BUY ||
      listing.type === PropertyListingType.OFF_PLAN
    ) {
      return t("sale");
    }
    return t("rent");
  };

  const prefix = getPrefix();
  let suffix = getSuffix();
  const hasSearchLocations = locations && locations.length > 0;

  if (!hasSearchLocations && !listing.property) {
    return t("default-title", {
      prefix,
      suffix,
    });
  }

  if (listing.property && !hasSearchLocations) {
    return t("property-type-no-location", {
      prefix,
      propertyType: st(`property-type.${listing.property?.toLowerCase()}`, {
        count: 2,
      }),
      suffix,
    });
  }

  suffix = t("suffix-with-location", {
    suffix,
    location: locations[0].label,
  });

  if (locations.length > 1) {
    suffix = t("suffix-with-multiple-locations", {
      suffix,
    });
  }

  if (hasSearchLocations && !listing.property) {
    return t("location-no-property-type", {
      prefix,
      suffix,
    });
  }

  if (listing.property && hasSearchLocations) {
    return t("full-title", {
      propertyType: st(`property-type.${listing.property?.toLowerCase()}`, {
        count: 2,
      }),
      suffix,
    });
  }
}
